export default "__VITE_ASSET__C$jkMP$u__"